import Fieldset from '@/components/Fieldset/Fieldset';
import NewLine from '@/components/Form/Fields/NewLine';
import type { IDefaultFormBuilderProps } from '@/components/Form/Fields/types';
import FormField from '@/components/Form/FormField';
import type { FormFieldsetStoryblok, FormStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react/rsc';
import { type FieldProps, useFormikContext } from 'formik';
import { type FC } from 'react';

import type { FormValues } from '../../types';

interface IFormFieldset extends FormFieldsetStoryblok, Omit<FieldProps, 'form'>, IDefaultFormBuilderProps {
  form: FormStoryblok;
}
const FormFieldset: FC<IFormFieldset> = (props) => {
  const { values } = useFormikContext<FormValues>();

  return (
    <Fieldset title={props.title} {...storyblokEditable(props)}>
      {props.fields?.map((fieldBlok, fieldIndex) => {
        if (fieldBlok.component === 'NewLine') {
          return <NewLine key={fieldBlok._uid} />;
        }
        return (
          <FormField
            key={fieldBlok._uid || `field-${fieldIndex}`}
            fieldBlok={fieldBlok}
            index={fieldIndex}
            formValues={values}
            form={props.form}
          />
        );
      })}
    </Fieldset>
  );
};

export default FormFieldset;
